import { useCallback } from 'react';
import { useAuthStorage } from './useAuthStorage';
import { useDynamicFieldsStorage } from './useDynamicFieldsStorage';
import { useUserSearchStorage } from './useUserSearchStorage';
import { useUsername } from './useUsername';
import { useOtpStorage } from './useOtpStorage';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';

export const useClearAllData = () => {
  const {clearAuth} = useAuthStorage();
  const {clearStorageData} = useDynamicFieldsStorage();
  const {clearUserData} = useUserSearchStorage();
  const {clearUsername} = useUsername();
  const {clearOtpData} = useOtpStorage();
  
  const clearAllData = useCallback(() => {
    console.log('Limpando todos os dados do usuário...');
    
    // Limpar dados de autenticação
    clearAuth();
    
    // Limpar dados dos formulários dinâmicos
    clearStorageData();
    
    // Limpar dados de busca de usuário
    clearUserData();
    
    // Limpar username
    clearUsername();
    
    // Limpar dados de OTP
    clearOtpData();
    
    // Limpar outros dados específicos que podem existir
    ApiLocalStorage.remove('@pwa-participantId');
    ApiLocalStorage.remove('user-data');
    
    console.log('Todos os dados foram limpos com sucesso');
  }, [clearAuth, clearStorageData, clearUserData, clearUsername, clearOtpData]);
  
  const clearRegistrationData = useCallback(() => {
    console.log('Limpando apenas dados de cadastro...');
    
    // Limpar apenas dados dos formulários dinâmicos
    clearStorageData();
    
    // Limpar dados de busca de usuário (se não foi encontrado)
    clearUserData();
    
    console.log('Dados de cadastro foram limpos');
  }, [clearStorageData, clearUserData]);
  
  return {
    clearAllData,
    clearRegistrationData
  };
};
